import gql from 'graphql-tag';
import { Fragments } from '@shared/api/fragments';

export const profile = gql`
  query ProfileQuery {
    me {
      ...Profile
    }
  }

  ${Fragments.user.profile}
`;

export const businessRole = gql`
  query BusinessRoleQuery($businessId: Int!) {
    me {
      ...UserBusinessRole
    }
  }

  ${Fragments.user.businessRole}
`;

// This query is used only to replace the following:
// frontend/native/src/graphql/ChannelListQueries.js:channelListContainerQuery
// This query causes instacrashes on Android prod builds for some
// unknown reason...
export const businessWithChannels = gql`
  query MyBusinessWithChannelsQuery($businessId: Int!) {
    me {
      id
      business(businessId: $businessId) {
        id
        # Note(fant): this makes sure that the business name
        # in the business switcher is set on first launch.
        name
        channels(filter: CONVERSATIONS) {
          ...ChannelListItem
        }
      }

      # Note(fant): having these two fields here is a hack to help
      # Sentry set the correct username in the context. This is
      # set in @src/core/thirdPartyIdentities.js:setUserForThirdParties
      # using the data from this query.
      firstName
      lastName
    }
  }

  ${Fragments.channel.listItem}
`;

export const personalDetails = gql`
  query PersonalDetailsQuery($id: Int!) {
    user: getUser(id: $id) {
      ...PersonalDetailsUser
    }
  }

  ${Fragments.user.personalDetails}
`;

export const userGlobalPermissions = gql`
  query UserGlobalPermissionsQuery {
    caslAbility: getAppAbility
  }
`;

export const listUserGroups = gql`
  query ListUserGroupsQuery($input: ListUserGroups!) {
    listUserGroups(input: $input) {
      hasMore
      userGroups {
        ...UserGroup
      }
    }
  }

  ${Fragments.user.userGroup}
`;

export const getUserGroup = gql`
  query GetUserGroupQuery($id: UUID!) {
    getUserGroup(id: $id) {
      ...UserGroup
    }
  }

  ${Fragments.user.userGroup}
`;

export const listUserGroupUserAssociations = gql`
  query ListUserGroupUserAssociationsQuery($input: ListUserGroupUserAssociations!) {
    listUserGroupUserAssociations(input: $input) {
      hasMore
      userGroupUserAssociations {
        ...UserGroupUserAssociation
      }
    }
  }

  ${Fragments.user.userGroupUserAssociation}
`;

export const listUsers = gql`
  query ListUsersQuery($input: ListUsers!, $customCacheKey: String!) {
    listUsers(input: $input) @connection(key: $customCacheKey) {
      users {
        ...CollectionViewUser
      }
      total
      hasMore
    }
  }

  ${Fragments.user.collectionViewUser}
`;

export const listDirectoryUsers = gql`
  query ListDirectoryUsersQuery($input: ListUsers!, $customCacheKey: String!, $businessId: Int!) {
    listUsers(input: $input) @connection(key: $customCacheKey) {
      users {
        ...DirectoryUser
        role(businessId: $businessId)
      }
      total
      hasMore
    }
  }

  ${Fragments.user.directoryUser}
`;

export const userBusiness = gql`
  query UserBusinessQuery($businessId: Int) {
    me {
      id
      business(businessId: $businessId) {
        id
        channels {
          id
          slug
          type
        }
        defaultChannel {
          id
          slug
          type
        }
      }
    }
  }
`;
